<div class="visit-room-summary">
  <div class="section no-padding general" [ngClass]="{ open: !isGeneralSectionCollapsed }">
    <div class="heading-wrapper general" (keydown.enter)="isGeneralSectionCollapsed = !isGeneralSectionCollapsed"
      (click)="isGeneralSectionCollapsed = !isGeneralSectionCollapsed" tabindex="0">
      <div class="inline">
        <img [ngClass]="{ chevron: true, open: !isGeneralSectionCollapsed }" src="assets/images/chevron-icon.svg"
          alt="arrow" />
        <h4>
          {{ 'pages.service.visitRoom.summary.generalTitle' | translate }}
        </h4>
      </div>
      <div class="actions">
        @if (application.initializationStatus !== 'InitializationDone') {
        <button class="secondary add-topic-btn" (click)="goToStep('1')">
          <img [attr.alt]="'imgAlt.editTopic' | translate" src="assets/images/edit-icon.svg" />
          {{ 'pages.service.visitRoom.summary.edit' | translate }}
        </button>
        }
      </div>
    </div>
    <div class="section-content general" [ngbCollapse]="isGeneralSectionCollapsed">
      <div class="lna-row full-width">
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.service.visitRoom.summary.roomName' | translate }}
          </p>
          <p class="form-value">{{ this.application.readingRoom.name }}</p>
        </div>
      </div>
      <div class="lna-row">
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.service.visitRoom.summary.visitDate' | translate }}
          </p>
          <p class="form-value">
            {{ this.formatDate(this.application.visitDate) }}
          </p>
        </div>
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.service.visitRoom.summary.timeFrom' | translate }}
          </p>
          <p class="form-value">
            {{ this.application.visitTimeFrom ? formatTime(this.application.visitTimeFrom) : '-' }}
          </p>
        </div>
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.service.visitRoom.summary.timeTo' | translate }}
          </p>
          <p class="form-value">
            {{ this.application.visitTimeTo ? formatTime(this.application.visitTimeTo) : '-' }}
          </p>
        </div>
      </div>
      <div class="lna-row full-width no-margin">
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.service.visitRoom.summary.notes' | translate }}
          </p>
          <p class="form-value">
            {{ this.application.visitInformation ? this.application.visitInformation : '-' }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="section no-padding topics" [ngClass]="{ open: !isResearchSectionCollapsed }">
    <div class="heading-wrapper" (keydown.enter)="isResearchSectionCollapsed = !isResearchSectionCollapsed"
      (click)="isResearchSectionCollapsed = !isResearchSectionCollapsed" tabindex="0">
      <div class="inline">
        <img [ngClass]="{ chevron: true, open: !isResearchSectionCollapsed }" src="assets/images/chevron-icon.svg"
          alt="arrow" />
        <h4>
          {{ 'pages.service.visitRoom.summary.researchTitle' | translate }}
        </h4>
      </div>
      <div class="actions">
        @if (application.initializationStatus !== 'InitializationDone') {
        <button class="secondary add-topic-btn" (click)="goToStep('2')">
          <img [attr.alt]="'imgAlt.editTopic' | translate" src="assets/images/edit-icon.svg" />
          {{ 'pages.service.visitRoom.summary.edit' | translate }}
        </button>
        }
      </div>
    </div>
    <div class="section-content topics" [ngbCollapse]="isResearchSectionCollapsed">
      @for (researchTopic of application.researchTopics; track researchTopic) {
      <div class="topic-wrapper" [ngClass]="{ open: researchTopicsCollapsed[$index] }">
        <div class="topic">
          <div class="name-wrapper" tabindex="0">
            <div class="topic-name">
              <img [attr.alt]="'imgAlt.check' | translate" src="assets/images/check-icon.svg" />
              <p>{{ researchTopic.name }}</p>
            </div>
          </div>
          <div class="actions-row">
            <div class="actions topic-actions">
              <button class="link-btn" (click)="researchTopicsCollapsed[$index] = !researchTopicsCollapsed[$index]">
                {{ 'pages.service.visitRoom.fullTopicDesc' | translate }}
                <img [ngClass]="{
                      chevron: true,
                      open: researchTopicsCollapsed[$index]
                    }" src="assets/images/chevron-icon.svg" alt="arrow" />
              </button>
            </div>
          </div>
        </div>
        <div class="topic-content" [ngbCollapse]="!researchTopicsCollapsed[$index]">
          <app-topic-info [topic]="getResearchTopic(researchTopic.id!)" />
        </div>
      </div>
      }
    </div>
  </div>

  <div class="section no-padding documents" [ngClass]="{ open: !isDocumentsSectionCollapsed }">
    <div class="heading-wrapper" (keydown.enter)="isDocumentsSectionCollapsed = !isDocumentsSectionCollapsed"
      (click)="isDocumentsSectionCollapsed = !isDocumentsSectionCollapsed" tabindex="0">
      <div class="inline">
        <img [ngClass]="{ chevron: true, open: !isDocumentsSectionCollapsed }" src="assets/images/chevron-icon.svg"
          alt="arrow" />
        <h4>
          {{ 'pages.service.visitRoom.summary.documentsTitle' | translate }}
        </h4>
      </div>
      <div class="actions">
        @if (application.initializationStatus !== 'InitializationDone') {
        <button class="secondary add-topic-btn" (click)="goToStep('3')">
          <img [attr.alt]="'imgAlt.editTopic' | translate" src="assets/images/edit-icon.svg" />
          {{ 'pages.service.visitRoom.summary.edit' | translate }}
        </button>
        }
      </div>
    </div>
    <div class="section-content documents" [ngbCollapse]="isDocumentsSectionCollapsed">
      <div class="documents-wrapper">
        <div class="document-header">
          <div class="label-wrapper heading-cell">
            <p>
              {{ 'pages.service.visitRoom.documentHeaderCode' | translate }}
            </p>
            <app-tooltip [withMargin]="false" [marginBottom]="false" text="documentCodeBackoffice" />
          </div>
          <div class="label-wrapper heading-cell">
            <p>{{ 'pages.service.visitRoom.documentNotes' | translate }}</p>
            <app-tooltip [withMargin]="false" [marginBottom]="false" text="orderDocumentNotes" />
          </div>
        </div>
        <div>
          @if (application.requestedDocuments?.length === 0) {
          <div class="no-documents-wrapper">
            <p class="no-documents">{{ 'pages.service.visitRoom.summary.noDocsOrdered' | translate }}</p>
          </div>
          } @else {
          @for (document of application.requestedDocuments; track document) {
          <div class="document-wrapper">
            <p>{{ document.code }}</p>
            <p class="document-notes">{{ document.notes }}</p>
          </div>
          }
          }
        </div>
        <div class="order-notes-wrapper" [ngClass]="{
            'border-top': application.requestedDocuments?.length === 0
          }">
          <div class="label-wrapper">
            <label class="form-label lna" for="requestedDocumentsInformation">
              {{ 'pages.service.visitRoom.orderNotes' | translate }}
            </label>
            <app-tooltip text="visitRoomOrderNotesBo" />
          </div>
          <p class="form-value">
            {{ application.requestedDocumentsInformation || '-' }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="section no-padding" [ngClass]="{ open: !isReadersInfoSectionCollapsed }">
    <div class="heading-wrapper" (keydown.enter)="isReadersInfoSectionCollapsed = !isReadersInfoSectionCollapsed"
      (click)="isReadersInfoSectionCollapsed = !isReadersInfoSectionCollapsed" tabindex="0">
      <div class="inline">
        <img [ngClass]="{ chevron: true, open: !isReadersInfoSectionCollapsed }" src="assets/images/chevron-icon.svg"
          alt="arrow" />
        <div class="header-wrapper">
          <h4>
            {{ 'pages.service.visitRoom.summary.readersInfoTitle' | translate }}
          </h4>
          <app-tooltip [marginBottom]="false" text="readersInfoTitleBackoffice" />
        </div>
      </div>
      <div class="actions">
        @if (application.initializationStatus !== 'InitializationDone') {
        <button class="secondary add-topic-btn" (click)="editReaderInfo()">
          <img [attr.alt]="'imgAlt.editTopic' | translate" src="assets/images/edit-icon.svg" />
          {{ 'pages.service.visitRoom.summary.edit' | translate }}
        </button>
        }
      </div>
    </div>
    <div class="section-content reader-info" [ngbCollapse]="isReadersInfoSectionCollapsed">
      <div class="lna-row full-width">
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.client.general.fullName' | translate }}
          </p>
          @if (false) {
          <p class="form-value">
            {{ application.client.name }}
            {{ application.client.surname || '-' }}
          </p>
          } @else {
          <p class="form-value">
            {{ application.client.name + ' ' + application.client.surname || '-' }}
          </p>
          }
        </div>
      </div>
      <div class="lna-row">
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.client.general.email' | translate }}
          </p>
          @if (false) {
          <p class="form-value">
            {{ application.client.email || '-' }}
          </p>
          } @else {
          <p class="form-value">{{ application.client.email || '-' }}</p>
          }
        </div>
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.client.general.phone' | translate }}
          </p>
          @if (false) {
          <p class="form-value">
            {{ application.client.phone || '-' }}
          </p>
          } @else {
          <p class="form-value">{{ application.client.phone || '-' }}</p>
          }
        </div>
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.client.general.postageAddress' | translate }}
          </p>
          @if (false) {
          <p class="form-value">{{ application.client.address || '-' }}</p>
          } @else {
          <p class="form-value">{{ application.client.address || '-' }}</p>
          }
        </div>
      </div>
      <div class="readers-card-wrapper">
        <div class="lna-row">
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.education' | translate }}
            </p>
            @if (false) {
            <p class="form-value">
              {{ application.readerCard.educationLevelName }}
            </p>
            } @else {
            <p class="form-value">
              {{ application.readerCard.educationLevelName || '-' }}
            </p>
            }
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.degree' | translate }}
            </p>
            @if (false) {
            <p class="form-value">
              {{ application.readerCard.scientificDegreeName || '-' }}
            </p>
            } @else {
            <p class="form-value">
              {{ application.readerCard.scientificDegreeName || '-' }}
            </p>
            }
          </div>
        </div>
        <div class="lna-row last">
          <div class="value-wrapper file-list">
            <div class="label-wrapper">
              <p class="form-label">
                {{ 'pages.client.readersCard.educationDocuments' | translate }}
              </p>
            </div>
            <app-file-upload [isEditMode]="false" [existingFiles]="readersCard?.doctoralCertificateFiles || []"
              [associatedEntityId]="readersCard?.id!" [isSubmitting]="false" />
            @if (readersCard?.doctoralCertificateFiles?.length === 0 && application.readerCard.scientificDegreeName ===
            'Doktors') {
            <div class="info-row danger">
              <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/danger-exclamation-mark.svg" />
              <p>
                {{ 'pages.service.visitRoom.summary.mustShowDoctoralCertificate' | translate }}
              </p>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-confirm-modal [title]="'deleteReadingRoomSubmission'" [confirmText]="'delete'"
  [isOpen]="isOpenConfirmDeleteSubmission" (confirm)="deleteReadingRoomSubmission()" (cancel)="onModalClose()" />
<app-service-form-actions [isLastStep]="true" [isDone]="this.application.initializationStatus === 'InitializationDone'"
  [isSubmitting]="isSubmitting" (exit)="back()" (continue)="submit()" (deleteDraft)="handleDeleteDraft()" />
